/* istanbul ignore file */
import React from 'react';
import { EnumField, TextField, BooleanOptionField, DateField, HtmlField, CommaListField } from 'framework/ui/field';
import {
  APPLICATION_TYPE,
  MOBILE_OS,
  PRESALE_REQUEST_TYPE,
} from 'domain/sales/opportunity/presale/request/shared/presaleRequestConstants';
import { AttachmentsListField } from 'domain/shared/artifact/field';
import {
  showApplicationTypeField,
  showCollaborationExpectationFiled,
  showHasAutomationTestingField,
  showMaterialsField,
  showMobileOSField,
  showPercentTestCoverageField,
  showReplacementReasonField,
  showRequiredFteField,
  showScopeOfWorkField,
  showSystemCompletionField,
  showSystemHostingLocationField,
  showTeamInvolvementField,
  showThirdPartyField,
} from 'domain/sales/opportunity/presale/request/shared/presaleRequestFieldVisibilityHelper';
import { useShowContext } from 'framework/show';

const PresaleRequestFields = () => {
  const { data } = useShowContext();

  return (
    <>
      <EnumField options={PRESALE_REQUEST_TYPE} source="requestType" label="Request type" />
      {showSystemCompletionField(data) ? (
        <TextField source="systemCompletionProgress" label="System completion progress" />
      ) : null}
      {showTeamInvolvementField(data) ? (
        <BooleanOptionField source="hasPreviousTeamInvolvement" label="Previous team involvement" />
      ) : null}
      {showCollaborationExpectationFiled(data) ? (
        <TextField source="collaborationExpectations" label="Collaboration expectations" />
      ) : null}
      {showSystemHostingLocationField(data) ? (
        <TextField source="systemHostingLocation" label="System hosting location" />
      ) : null}
      <DateField source="expectedCompletionAt" label="Expected timeline for completion" />
      {showHasAutomationTestingField(data) ? (
        <BooleanOptionField source="hasAutomatedTesting" label="Automated testing coverage" />
      ) : null}
      {showPercentTestCoverageField(data) ? (
        <TextField source="automatedTestingCoverage" label="% of coverage" />
      ) : null}
      {showApplicationTypeField(data) ? (
        <CommaListField
          mapValue={value => APPLICATION_TYPE[value]}
          source="applicationTypes"
          label="Application types"
        />
      ) : null}
      {showMobileOSField(data) ? (
        <CommaListField mapValue={value => MOBILE_OS[value]} source="mobileOperationSystems" label="Mobile OS" />
      ) : null}
      {showThirdPartyField(data) ? (
        <BooleanOptionField source="hasThirdPartyIntegrations" label="Third-Party integration" />
      ) : null}
      {showReplacementReasonField(data) ? <TextField source="replacementReason" label="Replacement reason" /> : null}
      {showRequiredFteField(data) ? <TextField source="requiredFte" label="Required FTE" /> : null}
      {showScopeOfWorkField(data) ? <TextField source="scopeOfWork" label="Scope of work" /> : null}
      {showMaterialsField(data) ? <HtmlField source="materials" label="Materials" /> : null}
      <AttachmentsListField source="attachmentIds" label="Attachments" />
    </>
  );
};

export default PresaleRequestFields;
